"use client"

import { matchesStoreId, transformStoreData } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/StoreLocator/utils/utils"
import ContactStoreInfoContent from "@/(admin)/modules/ui-builder/config/themes/tamda-one/ContactStoreInfo/components/ContactStoreInfoContent"
import ContactStoreInfoSkeleton from "@/(admin)/modules/ui-builder/config/themes/tamda-one/ContactStoreInfo/components/ContactStoreInfoSkeleton"
import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { useStores } from "@/hook/useStores"
import { ComponentConfig } from "@measured/puck"
import { useParams } from "next/navigation"
import { twMerge } from "tailwind-merge"
import { ContactStoreInfoProps } from "./types"

export const RenderConfig: ComponentConfig<ContactStoreInfoProps> = {
    render: ({ title, className, selectedStore }) => {
        const params = useParams()
        const storeLocale = useUIBuilderLocaleStore(state => state.locale)
        // Public có params.locale, editor thì không -> rơi về locale của blockContent đang sửa.
        const locale = (params?.locale as string) || storeLocale || "vi"
        const { stores: rawStores, loading, error } = useStores({ pageSize: 100, locale })
        const stores = transformStoreData(rawStores)

        if (loading) {
            return <ContactStoreInfoSkeleton />
        }

        // Filter stores if selectedStore is provided
        const filteredStores = selectedStore?.storeId
            ? stores.filter(store => matchesStoreId(store, selectedStore.storeId))
            : stores

        return (
            <div className={twMerge("w-full max-w-[1304px] mx-auto px-4", className)}>
                <ContactStoreInfoContent
                    stores={filteredStores}
                    title={title}
                    initialStoreId={selectedStore?.storeId}
                    locale={locale}
                />
            </div>
        )
    },
}
